import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import { AgentsProviderWrapper } from './context';
import AgentsListPage from './pages/AgentsListPage';
import AgentEditPage from './pages/AgentEditPage';

/**
 * Domain root for Agents.
 * Owns internal routes and wraps with providers.
 *
 * Paths are RELATIVE to the parent route that mounts this component:
 *   - Shell:      <Route path="agents/*">
 *   - Standalone: <Route path="agents/*"> in main.jsx
 *
 * Edit page tab routes (mirrors WorkspaceDetailPage pattern):
 *   /agents/:agentId                → redirect to /agents/:agentId/configuration
 *   /agents/:agentId/configuration  → Configuration tab
 *   /agents/:agentId/knowledge      → Knowledge tab
 *   /agents/:agentId/instructions   → Instructions tab
 *   /agents/:agentId/tools          → Tools tab
 *   /agents/:agentId/create         → Create tab
 */
const Agents = () => (
  <AgentsProviderWrapper>
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <AgentsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":agentId"
        element={
          <ProtectedRoute>
            <AgentEditPage />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="configuration" replace />} />
        <Route path="configuration" element={null} />
        <Route path="knowledge" element={null} />
        <Route path="instructions" element={null} />
        <Route path="tools" element={null} />
        <Route path="create" element={null} />
      </Route>
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  </AgentsProviderWrapper>
);

export default Agents;
